import React from 'react'
import { Link } from 'react-router-dom'
import Success from '../assets/success1.gif'

const RegSuccess = () => {
  return (
    <div className='regSuccessPage'>
        <h1>Registration Successfull..!!</h1>
        <img src={Success} alt='success' width={300} height={300} />
        <Link to="/account/login" className='loginBTN'>Login</Link>
    </div>
  )
}

export default RegSuccess